import {headers, urlbase} from "../constants/Constants";
import axios from "axios";

export async function getTest(token: string, test_id: string) {
    try {
        const url = urlbase().concat('test/questions?token='.concat(token).concat('&test_id=').concat(test_id));

        const memoResponse = await axios.get(url, {headers: headers()});

        return {code: memoResponse.status, message: memoResponse.statusText, data: memoResponse.data};
    } catch(e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function SubmitTest(token: string, test_id: string, body: any, group_test_id: string)   {
    try {
        const url = urlbase().concat('test/reactsubmit?token=').concat(token).concat('&test_id=').concat(test_id).concat(group_test_id);

        const submitResponse = await axios.post(url, JSON.stringify(body), {headers: headers()});

        return {code: submitResponse.status, message: submitResponse.statusText, data: submitResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function beginTest(token: string, test_id: string) {
    try {
        const url = urlbase().concat('test/start?token=').concat(token).concat('&test_id=').concat(test_id);

        const testStartResponse = await axios.get(url, {headers: headers()});

        return {code: testStartResponse.status, message: testStartResponse.statusText, data: testStartResponse.data};
    } catch(e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getAssignedTests(token: string) {
    try {
        const url = urlbase().concat("assignedtest/v2?token=").concat(token);

        const assignedTestsResponse = await axios.get(url, {headers: headers()});

        return {code: assignedTestsResponse.status, message: assignedTestsResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getPublicTests(token: string, subject: string, grade: string, searchTerm: string) {
    try {
        const url = urlbase().concat("publictest/v2?token=").concat(token).concat("&grade=").concat(grade).concat('&subject=').concat(subject).concat('&searchtest=').concat(searchTerm);

        const fetchTestsResponse = await axios.get(url, {headers: headers()});

        return {code: fetchTestsResponse.status, message: fetchTestsResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getPublicTestDetails(token: string, testID: string) {
    try {
        const url = urlbase().concat("testInformation?token=").concat(token).concat('&id=').concat(testID);

        const fetchTestsResponse = await axios.get(url, {headers: headers()});

        return {code: fetchTestsResponse.status, message: fetchTestsResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getAssignedTestSummary(token: string) {
    try {
        const url = urlbase().concat("assignedSummary?token=").concat(token);

        const fetchAssignedTestResponse = await axios.get(url, {headers: headers()});

        return {code: fetchAssignedTestResponse.status, message: fetchAssignedTestResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getAssignedTestDetails(token:string, test_id: string, group_test_id: string) {
    try {
        const url = urlbase().concat("assignedDetails?token=").concat(token).concat('&test_id=').concat(test_id).concat('&group_test_id=').concat(group_test_id);

        const fetchAssignedTestResponse = await axios.get(url, {headers: headers()});

        return {code: fetchAssignedTestResponse.status, message: fetchAssignedTestResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getReferencesNames(token: string, grade: string, subject_id: string, search_term: string) {
    try {
        const url = urlbase().concat("pdfNames?token=").concat(token).concat('&subjectID=').concat(subject_id).concat('&grade=').concat(grade).concat('&searchTerm=').concat(search_term);

        const fetchPdfNamesResponse = await axios.get(url, {headers: headers()});

        return {code: fetchPdfNamesResponse.status, message: fetchPdfNamesResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}

export async function getReferenceUrl(token: string, reference_id: string) {
    try {
        const url = urlbase().concat("pdfDetails?token=").concat(token).concat('&referenceID=').concat(reference_id);

        const fetchPdfInfoResponse = await axios.get(url, {headers: headers()});

        return {code: fetchPdfInfoResponse.status, message: fetchPdfInfoResponse.data};
    } catch (e) {
        return {code: e.code, message: e.response, data: e.response};
    }
}
